import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { ICardData } from '@partners/api';
import { ToDatePipe } from '@partners/utils';
import { CardFacade } from '../../facades/card';

@Component({
  selector: 'card-label',
  standalone: true,
  imports: [CommonModule, ToDatePipe],
  providers: [ToDatePipe],
  template: `
    <div class="nowrap mrg-bt-xs">
      <span>{{ brandName() }}</span>
      <span class="font--bold text-decoration--none">
        {{ last4Digits() }}
      </span>
    </div>
    <div class="nowrap mrg-bt-xs">
      <span>תוקף</span>
      <span class="font--bold text-decoration--none">
        {{ expirationDate() | toDate: 'MM/YY' }}
      </span>
    </div>
  `
})
export class CardLabelComponent {
  #cardFacade = inject(CardFacade);
  #cardData = computed<ICardData>(() => this.#cardFacade.cardFormat());

  brandName = computed<string>(() => this.#cardData().issuerCardBrandName);
  last4Digits = computed<number>(() => this.#cardData().issuerCardLast4Digits);
  expirationDate = computed<string>(() => this.#cardData().issuerCardExpirationDate);
}
